var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVideo
    ? _c(
        "div",
        {
          staticClass: "rb-lazy-media__container",
          class: {
            "rb-lazy-media__container--is-video": _vm.isVideo,
            "rb-lazy-media--loading": _vm.loading,
          },
        },
        [
          _c(
            "video",
            {
              ref: "video",
              staticClass: "rb-lazy-media",
              attrs: {
                playsinline: "",
                controls: false,
                poster: _vm.poster,
                loop: _vm.loop,
              },
              domProps: { muted: _vm.muted },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            },
            [
              _c("source", {
                attrs: { "data-src": _vm.src, type: "video/mp4" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.controls
            ? _c("div", { staticClass: "rb-lazy-media__video-controls" }, [
                !_vm.playing
                  ? _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          "data-element-id": "X_Pdp_Video_Play",
                          "data-description": _vm.videoName,
                        },
                        on: {
                          keypress: function ($event) {
                            $event.preventDefault()
                            return _vm.onPlayKeypress($event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "common__icon",
                            class: _vm.playClass,
                            on: { click: _vm.play },
                          },
                          [_vm._v("play")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.playing
                  ? _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          "data-element-id": "X_Pdp_Video_Pause",
                          "data-description": _vm.videoName,
                        },
                        on: {
                          keypress: function ($event) {
                            $event.preventDefault()
                            return _vm.onPauseKeypress($event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "common__icon",
                            class: _vm.pauseClass,
                            on: { click: _vm.pause },
                          },
                          [_vm._v("pause")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      )
    : _c(
        "picture",
        {
          staticClass: "rb-lazy-media__container",
          class: {
            "rb-lazy-media--loading": _vm.loading,
            "rb-lazy-media--custom-element": _vm.isCustomElementImage,
          },
        },
        [
          _vm.isCustomElementImage
            ? [_vm._t("custom-element-image")]
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "view",
                rawName: "v-view",
                value: _vm.onViewportIntersection,
                expression: "onViewportIntersection",
              },
            ],
            ref: "image",
            staticClass: "rb-lazy-media",
            class: { "--no-pointer-event": _vm.noPointerEventImage },
            attrs: {
              "data-src": _vm.src,
              alt: _vm.alt,
              fetchpriority: _vm.fetchpriority,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
            },
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }